export const DEFAULT_PAGE_SIZE = 10

export const PAGE_SIZE_OPTIONS: number[] = [10, 15, 20]
